<template>
  <div class="form-group row" style="margin-bottom: 5px;">
    <label class="col-xs-12 col-sm-5 col-md-5 col-lg-5 control-label" for="timesheet_day_time_start">
      {{fieldLabel}}:&nbsp;
    </label>
    <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
      <div style="display: flex">
        <div>
          <timesheet-field-text v-if="fieldType == 'text'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-text-area v-else-if="fieldType == 'textarea'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-time v-else-if="fieldType == 'time'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-date v-else-if="fieldType == 'date'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-duration v-else-if="fieldType == 'duration'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-duration-total v-else-if="fieldType == 'duration_total'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-dropdown v-else-if="fieldType == 'dropdown'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-multistate v-else-if="fieldType == 'multistate'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
          <timesheet-field-dropdown-hours v-if="fieldType == 'dropdown_hours'" :layout="layoutData" :value="value" :index="index" @change="onChange" />
        </div>
        <div style="padding-left: 5px">
          <button v-if="showAddButton" class="btn green-jungle" @click="addClick"><i class="fa fa-plus"></i></button>
          <button v-if="showRemoveButton" class="btn red" @click="removeClick"><i class="fa fa-times"></i></button>
        </div>
      </div>
      <div v-for="error in errors">
        <span class="font-red">{{error}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import TimesheetFieldDropdown from './TimesheetFieldDropdown.vue'
  import TimesheetFieldDuration from './TimesheetFieldDuration.vue'
  import TimesheetFieldDurationTotal from './TimesheetFieldDurationTotal.vue'
  import TimesheetFieldMultistate from './TimesheetFieldMultistate.vue'
  import TimesheetFieldText from './TimesheetFieldText.vue'
  import TimesheetFieldTextArea from './TimesheetFieldTextArea.vue'
  import TimesheetFieldTime from './TimesheetFieldTime.vue'
  import TimesheetFieldDropdownHours from './TimesheetFieldDropdownHours.vue'
  import TimesheetFieldDate from './TimesheetFieldDate.vue'
  
  export default {
    components: { 
      TimesheetFieldText,
      TimesheetFieldTime,
      TimesheetFieldDuration,
      TimesheetFieldDurationTotal,
      TimesheetFieldDropdown,
      TimesheetFieldMultistate,
      TimesheetFieldTextArea,
      TimesheetFieldDropdownHours,
      TimesheetFieldDate,
    },
    name: "timesheet-field",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      },
      errors: {
        type: Array,
        default: () => ([])
      },
      showAddButton: {
        type: Boolean,
        default: false
      },
      showRemoveButton: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        layoutData: this.layout
      }
    },
    created () {
      if(this.layoutData.errors === undefined) {
        this.$set(this.layoutData, "errors", []);
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      }
    },
    methods: {
      onChange(e,l,v,i) {
        this.layoutData.value = v;
        this.layoutData.errors.splice(0,this.layoutData.errors.length);
        this.$emit("change", e, l, v, i)
      },
      addClick(e) {
        this.$emit("addClick", e, this.layoutData, this.index)
      },
      removeClick(e) {
        this.$emit("removeClick", e, this.layoutData, this.index)
      }
    }
  }
</script>

<style lang="scss">
.is-invalid {
  border-color: #f00;
  color: #f00;

  &.btn-group .btn {
    border-top-color: #f00;
    border-bottom-color: #f00;

    &:first-child {
      border-left-color: #f00;
    }

    &:last-child {
      border-right-color: #f00;
    }
  }
}

.control-label {
  text-align: right !important; 
  padding-right: 0; 
  padding-left: 0; 
  margin-top: 5px
}

@media screen and (max-width: 767px) {
  .control-label {
    text-align: left !important;
    padding-left: 15px; 
  }
}
</style>